@if (formGroup) {
  <div class="default-notifications-wrapper" [formGroup]="formGroup">
    <div class="default-notifications-row">
      <div class="title">Account notifications</div>
      <div class="option-title">In-app alerts</div>
      <div class="option-title">Emails</div>
    </div>
    @for (notification of defaultNotifications; track notification) {
      <div class="default-notifications-row" [formGroupName]="notification">
        <div>{{ NotificationsSettingsToDisplayName.get(notification) }}</div>
        <div class="checkbox-notification">
          <pdq-checkbox label="" formControlName="enabled"></pdq-checkbox>
          @if (formGroup?.value[notification].enabled) {
            <div class="sound-wrapper">
              <img
                [src]="
                  formGroup?.value[notification].sound ? 'assets/icons/sound-on.svg' : 'assets/icons/sound-off.svg'
                "
                (click)="soundChanged(notification)" />
            </div>
          }
        </div>
        <div class="checkbox-notification">
          <pdq-checkbox label="" formControlName="email"></pdq-checkbox>
        </div>
      </div>
    }
  </div>
}
<footer [ngClass]="formGroup?.dirty ? 'apear' : 'initial'">
  <span>You have unsaved notifications</span>
  <pdq-button
    variant="secondary"
    [disabled]="isLoading"
    (click)="resetForm()"
    label="cancel"
    class="action-btn"></pdq-button>
  <pdq-button
    variant="primary"
    type="submit"
    label="save"
    class="action-btn"
    (click)="onSubmit()"
    [loading]="isLoading">
  </pdq-button>
</footer>
